import { GLOBAL_REPORT_TYPES } from "../../type/globalReportTypes";
import { GlobalReportCardGrid } from "../../components/GlobalReportCardGrid/GlobalReportCardGrid";
import css from "./GlobalReportLanding.module.css";

export function GlobalReportLanding() {
  return (
    <div className={css.container}>
      <GlobalReportCardGrid types={GLOBAL_REPORT_TYPES} />
    </div>
  );
}
